// Every origin/hostname the portal needs to know about, derived from the
// Firebase project id so a project rebuild only changes .env.
const PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;

export const WEB_APP_HOST = `${PROJECT_ID}.web.app`;
export const FIREBASEAPP_HOST = `${PROJECT_ID}.firebaseapp.com`;
export const LOCAL_ORIGIN = "http://localhost:3000";

// Local dev is served by the dev-portal tenant on the *.firebaseapp.com origin.
export const DEV_PORTAL_ORIGIN = (
  process.env.REACT_APP_DEV_PORTAL_ORIGIN || `https://${FIREBASEAPP_HOST}`
).replace(/\/+$/, "");

// Tenant custom domains (override with REACT_APP_TENANT_HOSTS, comma-separated).
export const TENANT_HOSTS = (
  process.env.REACT_APP_TENANT_HOSTS ||
  "quantum.pirm.io,balbec.pirm.io,lendistry.pirm.io,loanmart.pirm.io"
)
  .split(",")
  .map((s) => s.trim())
  .filter(Boolean);

// HQ tooling (cross-tenant user provisioning) only on the PIRM portal itself.
export const HQ_HOSTNAMES = [WEB_APP_HOST, FIREBASEAPP_HOST, "localhost"];

export const PORTAL_ORIGINS = [
  `https://${WEB_APP_HOST}`,
  `https://${FIREBASEAPP_HOST}`,
  LOCAL_ORIGIN,
  ...TENANT_HOSTS.map((h) => `https://${h}`),
];

export const currentOrigin = () => {
  const { protocol, hostname, port } = window.location;
  return `${protocol}//${hostname}${port ? `:${port}` : ""}`;
};

// Orgs whose addon objects carry no pirm_addon__ namespace: the dev org on the
// *.firebaseapp.com origin and localhost. The *.web.app HQ portal is the PIRM
// production org, which is namespaced.
export const isUnmanagedOrg = () =>
  [`https://${FIREBASEAPP_HOST}`, LOCAL_ORIGIN].includes(currentOrigin());
